import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';

import Checkbox from '@material-ui/core/Checkbox';
import $ from "jquery";

export default class SystemAdminPermission extends Component {

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission } = authentication.currentUserValue;

        this.state = {
            user_permission: user_permission,
            userid: user_id,
            pages: [],
            project_home: [],
            addIsOpen: false,
            permissionIsOpen: false,
            srcIsOpen: false,
            deleteIsOpen: false,
            updateIsOpen: false,
            masterType: '',
            masterType_name: '',
            content_id: '',
            methodOpen: '',
            jwt: jwt,
            add_id: '',
            add_name: '',
            add_description: '',
            add_type: '',
            active: true,
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            src_active: false,
            src_nonactive: false,
            page: 0,
            rowsPerPage: 10,
            miss_su: helpers.getUserType(user_type, "su"),
            dashboard_presale: false,
            dashboard_homecare: false,
            dashboard_juristic: false,
            member_view: false,
            member_add: false,
            member_edit: false,
            member_delete: false,
            nirvana_view: false,
            nirvana_add: false,
            nirvana_edit: false,
            nirvana_delete: false,
            residents_view: false,
            residents_add: false,
            residents_edit: false,
            residents_delete: false,
            guest_view: false,
            guest_add: false,
            guest_edit: false,
            guest_delete: false,
            register_view: false,
            register_add: false,
            residence_view: false,
            residence_add: false,
            residence_edit: false,
            residence_delete: false,
            residence_export: false,
            residence_import: false,
            hometype_view: false,
            hometype_add: false,
            hometype_edit: false,
            hometype_delete: false,
            projecttype_view: false,
            projecttype_add: false,
            projecttype_edit: false,
            projecttype_delete: false,
            projecthome_view: false,
            projecthome_add: false,
            projecthome_edit: false,
            projecthome_delete: false,
            worksheethc_view: false,
            worksheethc_add: false,
            worksheethc_edit: false,
            worksheethc_done: false,
            mainservicehc_view: false,
            mainservicehc_add: false,
            mainservicehc_edit: false,
            mainservicehc_delete: false,
            subservicehc_view: false,
            subservicehc_add: false,
            subservicehc_edit: false,
            subservicehc_delete: false,
            worksheetjt_view: false,
            worksheetjt_add: false,
            worksheetjt_edit: false,
            worksheetjt_done: false,
            mainservicejt_view: false,
            mainservicejt_add: false,
            mainservicejt_edit: false,
            mainservicejt_delete: false,
            subservicejt_view: false,
            subservicejt_add: false,
            subservicejt_edit: false,
            subservicejt_delete: false,
            reporthc_view: false,
            reporthc_download: false,
            reportjt_view: false,
            reportjt_download: false,
            reportps_view: false,
            reportps_download: false,
            amount_view: false,
            amount_add: false,
            amount_edit: false,
            amount_delete: false,
            amount_download: false,
            commonfee_view: false,
            commonfee_add: false,
            commonfee_edit: false,
            commonfee_delete: false,
            community_view: false,
            community_add: false,
            community_edit: false,
            community_delete: false,
            boxnews_view: false,
            boxnews_add: false,
            boxnews_edit: false,
            boxnews_delete: false,
            boxnews_send: false,
            regulation_view: false,
            regulation_add: false,
            regulation_edit: false,
            regulation_delete: false,
            servicefee_view: false,
            servicefee_add: false,
            servicefee_edit: false,
            servicefee_delete: false,
            overviewfee_view: false,
            overviewfee_add: false,
            overviewfee_edit: false,
            overviewfee_delete: false,
            houseprogress_view: false,
            houseprogress_add: false,
            houseprogress_edit: false,
            houseprogress_delete: false,
            houseprogress_download: false,
            privilegemgm_view: false,
            privilegemgm_add: false,
            privilegemgm_edit: false,
            privilegemgm_delete: false,
            privilegeevent_view: false,
            privilegeevent_add: false,
            privilegeevent_edit: false,
            privilegeevent_delete: false,
            privilegeeventregister_view: false,
            privilegepoint_view: false,
            privilegepoint_add: false,
            privilegepoint_edit: false,
            privilegepoint_delete: false,
            privilegepointhistory_view: false,
            beyondservice_view: false,
            beyondservice_add: false,
            beyondservice_edit: false,
            beyondservice_delete: false,
            blogs_view: false,
            blogs_add: false,
            blogs_edit: false,
            blogs_delete: false,
            tips_view: false,
            tips_add: false,
            tips_edit: false,
            tips_delete: false,
            mainservicetips_view: false,
            mainservicetips_add: false,
            mainservicetips_edit: false,
            mainservicetips_delete: false,
            subservicetips_view: false,
            subservicetips_add: false,
            subservicetips_edit: false,
            subservicetips_delete: false,
            bannerhome_view: false,
            bannerhome_add: false,
            bannerhome_edit: false,
            bannerhome_delete: false,
            bannerpromotion_view: false,
            bannerpromotion_add: false,
            bannerpromotion_edit: false,
            bannerpromotion_delete: false,
            projectdetail_view: false,
            projectdetail_add: false,
            projectdetail_edit: false,
            projectdetail_delete: false,
            trackingdata_view: false,
            presaleregister_view: false,
            presalepromotion_view: false,
            presalecontact_view: false,
            aboutus_view: false,
            aboutus_add: false,
            aboutus_edit: false,
            aboutus_delete: false,
            contactus_add: false,
            contactus_edit: false,
            emergencycall_view: false,
            emergencycall_add: false,
            emergencycall_edit: false,
            emergencycall_delete: false,
            mailandparcel_view: false,
            mailandparcel_add: false,
            mailandparcel_edit: false,
            mailandparcel_delete: false,
            chat_view: false,
            notification_view: false,
            notification_add: false,
            notification_edit: false,
            notification_delete: false,
            notification_send: false,
            policy_view: false,
            policy_edit: false,
            policytracking_view: false,
            policytracking_export: false,
            permission_view: false,
            permission_add: false,
            permission_edit: false,
            permission_delete: false,
            permission_manage: false,
            users_view: false,
            users_add: false,
            users_edit: false,
            users_delete: false,
            member_logs: false,
            configemail: false,
            worksheetcc_view: false,
            worksheetcc_edit: false,
            worksheetcc_done: false,
            mainservicecc_view: false,
            mainservicecc_add: false,
            mainservicecc_edit: false,
            mainservicecc_delete: false,
            groupservicecc_view: false,
            groupservicecc_add: false,
            groupservicecc_edit: false,
            groupservicecc_delete: false,
            subservicecc_view: false,
            subservicecc_add: false,
            subservicecc_edit: false,
            subservicecc_delete: false,
            member_payment: false,
            member_houseprogress: false,
            member_privileges: false,
            member_beyondservice: false,
            member_repair: false,
            member_appeal: false,
            member_blogs: false,
            member_tips: false,
            member_addmember: false,
            member_juristic: false,
            member_chat: false,
            member_mail: false,
            member_emergencycall: false,
            member_presale: false,
            member_get_member: false,
            groupservicejt_view: false,
            groupservicejt_add: false,
            groupservicejt_edit: false,
            groupservicejt_delete: false,
            groupservicehc_view: false,
            groupservicehc_add: false,
            groupservicehc_edit: false,
            groupservicehc_delete: false,
            dashboard_callcenter: false,
            // member_import: false,
            member_export: false,
            member_download: false,
            residents_download: false,
            memberdelete_view: false,
            memberdelete_export: false,
            nirvana_export: false,
            register_export: false,
            auto_view: false,
            auto_import: false,
            auto_export: false,
            auto_download: false,
            hometype_export: false,
            projecttype_export: false,
            projecthome_export: false,
            amount_import: false,
            amount_export: false,
            amount_downloadAll: false,
            servicefee_import: false,
            servicefee_download: false,
            privilegemgm_export: false,
            privilegeevent_export: false,
            privilegeeventregister_export: false,
            beyondservice_import: false,
            beyondservice_export: false,
            beyondservice_download: false,
            tips_export: false,
            bannerhome_export: false,
            bannerpromotion_export: false,
            projectdetail_export: false,
            trackingdata_export: false,
            presaleregister_export: false,
            presalepromotion_export: false,
            presalecontact_export: false,
            policymember_view: false,
            policymember_export: false,
            houseprogress_export: false,
            worksheet_view: false,
            mycase_view: true,
            mycase_edit: false,
            donecase_view:  true,
            donecase_edit: false,
            allcase_view: true,
            allcase_edit: false,
            customeprofile_view: true,
            customeprofile_viewcase: false,
            customeprofile_create: false,
            customehis_view: false,
            customehis_edit: false,
            newform_create: false,
            spinner: false,
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.closeAdd = this.closeAdd.bind(this);
        this.openAdd = this.openAdd.bind(this);
        this.submitAdd = this.submitAdd.bind(this)

        this.openView = this.openView.bind(this);
        this.openEdit = this.openEdit.bind(this);

        this.change = this.change.bind(this);
        this.dataTable = this.dataTable.bind(this);

        this.closeSrc = this.closeSrc.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);

        this.handleCheck = this.handleCheck.bind(this)

        this.onChange = this.onChange.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.closeModelUpdate = this.closeModelUpdate.bind(this);


        this.handleActiveSrcCheck = this.handleActiveSrcCheck.bind(this)
        this.handleNonActiveSrcCheck = this.handleNonActiveSrcCheck.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);


        this.openDelete = this.openDelete.bind(this);
        this.submitDelete = this.submitDelete.bind(this);
        this.closeDelete = this.closeDelete.bind(this);

        this.submitPermission = this.submitPermission.bind(this)
        this.openPermission = this.openPermission.bind(this);
        this.closePermission = this.closePermission.bind(this);

        this.submitEdit = this.submitEdit.bind(this);

        this.dataTable();
    }

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };
    clearStateFilterForm() {
        this.setState({
            add_type:'',
            add_name:'',
            src_active:'',
            src_nonactive:'',
        })
    }

    clearStatePermissionForm() {
        this.setState({
            dashboard_presale: false,
            dashboard_homecare: false,
            dashboard_juristic: false,
            member_view: false,
            member_add: false,
            member_edit: false,
            member_delete: false,
            nirvana_view: false,
            nirvana_add: false,
            nirvana_edit: false,
            nirvana_delete: false,
            residents_view: false,
            residents_add: false,
            residents_edit: false,
            residents_delete: false,
            guest_view: false,
            guest_add: false,
            guest_edit: false,
            guest_delete: false,
            register_view: false,
            register_add: false,
            residence_view: false,
            residence_add: false,
            residence_edit: false,
            residence_delete: false,
            residence_export: false,
            residence_import: false,
            hometype_view: false,
            hometype_add: false,
            hometype_edit: false,
            hometype_delete: false,
            projecttype_view: false,
            projecttype_add: false,
            projecttype_edit: false,
            projecttype_delete: false,
            projecthome_view: false,
            projecthome_add: false,
            projecthome_edit: false,
            projecthome_delete: false,
            worksheethc_view: false,
            worksheethc_add: false,
            worksheethc_edit: false,
            worksheethc_done: false,
            mainservicehc_view: false,
            mainservicehc_add: false,
            mainservicehc_edit: false,
            mainservicehc_delete: false,
            subservicehc_view: false,
            subservicehc_add: false,
            subservicehc_edit: false,
            subservicehc_delete: false,
            worksheetjt_view: false,
            worksheetjt_add: false,
            worksheetjt_edit: false,
            worksheetjt_done: false,
            mainservicejt_view: false,
            mainservicejt_add: false,
            mainservicejt_edit: false,
            mainservicejt_delete: false,
            subservicejt_view: false,
            subservicejt_add: false,
            subservicejt_edit: false,
            subservicejt_delete: false,
            reporthc_view: false,
            reporthc_download: false,
            reportjt_view: false,
            reportjt_download: false,
            reportps_view: false,
            reportps_download: false,
            amount_view: false,
            amount_add: false,
            amount_edit: false,
            amount_delete: false,
            amount_download: false,
            commonfee_view: false,
            commonfee_add: false,
            commonfee_edit: false,
            commonfee_delete: false,
            community_view: false,
            community_add: false,
            community_edit: false,
            community_delete: false,
            boxnews_view: false,
            boxnews_add: false,
            boxnews_edit: false,
            boxnews_delete: false,
            boxnews_send: false,
            regulation_view: false,
            regulation_add: false,
            regulation_edit: false,
            regulation_delete: false,
            servicefee_view: false,
            servicefee_add: false,
            servicefee_edit: false,
            servicefee_delete: false,
            overviewfee_view: false,
            overviewfee_add: false,
            overviewfee_edit: false,
            overviewfee_delete: false,
            houseprogress_view: false,
            houseprogress_add: false,
            houseprogress_edit: false,
            houseprogress_delete: false,
            houseprogress_download: false,
            privilegemgm_view: false,
            privilegemgm_add: false,
            privilegemgm_edit: false,
            privilegemgm_delete: false,
            privilegeevent_view: false,
            privilegeevent_add: false,
            privilegeevent_edit: false,
            privilegeevent_delete: false,
            privilegeeventregister_view: false,
            privilegepoint_view: false,
            privilegepoint_add: false,
            privilegepoint_edit: false,
            privilegepoint_delete: false,
            privilegepointhistory_view: false,
            beyondservice_view: false,
            beyondservice_add: false,
            beyondservice_edit: false,
            beyondservice_delete: false,
            blogs_view: false,
            blogs_add: false,
            blogs_edit: false,
            blogs_delete: false,
            tips_view: false,
            tips_add: false,
            tips_edit: false,
            tips_delete: false,
            mainservicetips_view: false,
            mainservicetips_add: false,
            mainservicetips_edit: false,
            mainservicetips_delete: false,
            subservicetips_view: false,
            subservicetips_add: false,
            subservicetips_edit: false,
            subservicetips_delete: false,
            bannerhome_view: false,
            bannerhome_add: false,
            bannerhome_edit: false,
            bannerhome_delete: false,
            bannerpromotion_view: false,
            bannerpromotion_add: false,
            bannerpromotion_edit: false,
            bannerpromotion_delete: false,
            projectdetail_view: false,
            projectdetail_add: false,
            projectdetail_edit: false,
            projectdetail_delete: false,
            trackingdata_view: false,
            presaleregister_view: false,
            presalepromotion_view: false,
            presalecontact_view: false,
            aboutus_view: false,
            aboutus_add: false,
            aboutus_edit: false,
            aboutus_delete: false,
            contactus_add: false,
            contactus_edit: false,
            emergencycall_view: false,
            emergencycall_add: false,
            emergencycall_edit: false,
            emergencycall_delete: false,
            mailandparcel_view: false,
            mailandparcel_add: false,
            mailandparcel_edit: false,
            mailandparcel_delete: false,
            chat_view: false,
            notification_view: false,
            notification_add: false,
            notification_edit: false,
            notification_delete: false,
            notification_send: false,
            policy_view: false,
            policy_edit: false,
            policytracking_view: false,
            policytracking_export: false,
            permission_view: false,
            permission_add: false,
            permission_edit: false,
            permission_delete: false,
            permission_manage: false,
            users_view: false,
            users_add: false,
            users_edit: false,
            users_delete: false,
            member_logs: false,
            configemail: false,
            worksheetcc_view: false,
            worksheetcc_edit: false,
            worksheetcc_done: false,
            mainservicecc_view: false,
            mainservicecc_add: false,
            mainservicecc_edit: false,
            mainservicecc_delete: false,
            groupservicecc_view: false,
            groupservicecc_add: false,
            groupservicecc_edit: false,
            groupservicecc_delete: false,
            subservicecc_view: false,
            subservicecc_add: false,
            subservicecc_edit: false,
            subservicecc_delete: false,
            member_payment: false,
            member_houseprogress: false,
            member_privileges: false,
            member_beyondservice: false,
            member_repair: false,
            member_appeal: false,
            member_blogs: false,
            member_tips: false,
            member_addmember: false,
            member_juristic: false,
            member_chat: false,
            member_mail: false,
            member_emergencycall: false,
            member_presale: false,
            member_get_member: false,
            groupservicejt_view: false,
            groupservicejt_add: false,
            groupservicejt_edit: false,
            groupservicejt_delete: false,
            groupservicehc_view: false,
            groupservicehc_add: false,
            groupservicehc_edit: false,
            groupservicehc_delete: false,
            dashboard_callcenter: false,
            member_import: false,
            member_export: false,
            member_download: false,
            residents_download: false,
            memberdelete_view: false,
            memberdelete_export: false,
            nirvana_export: false,
            register_export: false,
            auto_view: false,
            auto_import: false,
            auto_export: false,
            auto_download: false,
            hometype_export: false,
            projecttype_export: false,
            projecthome_export: false,
            amount_import: false,
            amount_export: false,
            amount_downloadAll: false,
            servicefee_import: false,
            servicefee_download: false,
            privilegemgm_export: false,
            privilegeevent_export: false,
            privilegeeventregister_export: false,
            beyondservice_import: false,
            beyondservice_export: false,
            beyondservice_download: false,
            tips_export: false,
            bannerhome_export: false,
            bannerpromotion_export: false,
            projectdetail_export: false,
            trackingdata_export: false,
            presaleregister_export: false,
            presalepromotion_export: false,
            presalecontact_export: false,
            policymember_view: false,
            policymember_export: false,
            houseprogress_export: false,
            worksheet_view: false,
            mycase_view: true,
            mycase_edit: false,
            donecase_view:  true,
            donecase_edit: false,
            allcase_view: true,
            allcase_edit: false,
            customeprofile_view: true,
            customeprofile_viewcase: false,
            customeprofile_create: false,
            customehis_view: false,
            customehis_edit: false,
            newform_create: false,
            spinner: false,
        })
    }

    dataTable() {
        try {
            this.setState({spinner:true})
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            fetch(config.url.API_URL + '/getpermissionType/', requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data
                    this.setState({
                        pages: [].concat(data),
                        spinner: false
                    });
                }).catch(err => {
                    console.log(`error durring fetch datatable`)
                    console.log(err)
                    this.setState({
                        pages: [],
                        spinner: false
                    });
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    dataTableSrc() {
        try {
            this.setState({
                spinner: true
            });
    
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            var body = `?active=${this.state.src_active}&nonactive=${this.state.src_nonactive}&type=${this.state.add_type}&name=${this.state.add_name}`
    
            fetch(config.url.API_URL + '/getpermissionTypeSrc' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        pages: [].concat(data.data),
                        spinner: false
                    });
    
                }).catch(err => {
                    console.log(`error durring fetch filter`)
                    console.log(err)
    
                    this.setState({
                        pages: [],
                        spinner: false
                    });
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openAdd() {
        this.setState({
            addIsOpen: true,
            methodOpen: 'add',
            add_id: '',
            add_name: '',
            add_description: '',
            add_type: '',
        });
    }

    submitSrc(e) {
        this.dataTableSrc()
        this.clearStateFilterForm()
        this.setState({ srcIsOpen: false });
    }

    openView(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            var body = `?type=${e.currentTarget.attributes["data-id"].value.split(",")[1]}`
            fetch(config.url.API_URL + `/getpermissionType/${e.currentTarget.attributes["data-id"].value.split(",")[0]}${body}`, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data;
                    this.setState({
                        add_id: data.id,
                        add_name: data.name,
                        add_type: data.type === "Member" ? "Mobile" : data.type == "User" ? "Back office" : "ไม่พบข้อมูล",
                        add_description: data.description,
                        add_active_status: data.active_status
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view'
                    });
                }).catch(err => {
                    console.log(`error durring openview`)
                    console.log(err)
                    this.setState({
                        add_id: '',
                        add_name: '',
                        add_type: '',
                        add_description: '',
                        add_active_status: ''
                    });
                });
        } catch (error) {
            console.log(error)
            // //window.location.reload(); // Reload the page
        }
    }

    submitEdit(e) {
        try {
            if (!this.state.add_name) {
                alert('ไม่พบข้อมูลชื่อประเภท');
                return;
            }
    
            if (!this.state.add_type) {
                alert('ไม่พบข้อมูลประเภท');
                return;
            }
    
            if (!this.state.add_description) {
                alert('ไม่พบข้อมูลรายละเอียด');
                return;
            }
    
            //console.log(jwt);
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    name: this.state.add_name,
                    description: this.state.add_description,
                    active_status: this.state.active ? 1 : 0,
                    type: this.state.add_type,
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/getpermissionType/' + this.state.add_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        spinner: true
                    });
                }).catch(err => {
                    console.log(`error durring submit edit`)
                    console.log(err)
                });
            this.dataTable()
            this.setState({ addIsOpen: false });
        } catch (err) {
            console.log(`error durring permission`)
            console.log(err)
        }
    }

    openPermission(e) {
        try {
            var master_type = e.currentTarget.attributes["data-id"].value

            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            var body = `?type=${e.currentTarget.attributes["data-id"].value.split(",")[1]}`
            fetch(config.url.API_URL + `/getpermissionType/${e.currentTarget.attributes["data-id"].value.split(",")[0]}${body}`, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data.menus;
                    if (master_type.split(",")[1] == "User") {
                        if (data.length > 0) {
                            this.setState({
                                dashboard_presale: data[0].permission,
                                dashboard_homecare: data[1].permission,
                                dashboard_juristic: data[2].permission,
                                member_view: data[3].permission,
                                member_add: data[4].permission,
                                member_edit: data[5].permission,
                                member_delete: data[6].permission,
                                residents_view: data[7].permission,
                                residents_add: data[8].permission,
                                residents_edit: data[9].permission,
                                residents_delete: data[10].permission,
                                guest_view: data[11].permission,
                                guest_add: data[12].permission,
                                guest_edit: data[13].permission,
                                guest_delete: data[14].permission,
                                register_view: data[15].permission,
                                register_add: data[16].permission,
                                residence_view: data[17].permission,
                                residence_add: data[18].permission,
                                residence_edit: data[19].permission,
                                residence_delete: data[20].permission,
                                residence_export: data[21].permission,
                                residence_import: data[22].permission,
                                hometype_view: data[23].permission,
                                hometype_add: data[24].permission,
                                hometype_edit: data[25].permission,
                                hometype_delete: data[26].permission,
                                projecttype_view: data[27].permission,
                                projecttype_add: data[28].permission,
                                projecttype_edit: data[29].permission,
                                projecttype_delete: data[30].permission,
                                projecthome_view: data[31].permission,
                                projecthome_add: data[32].permission,
                                projecthome_edit: data[33].permission,
                                projecthome_delete: data[34].permission,
                                worksheethc_view: data[35].permission,
                                worksheethc_add: data[36].permission,
                                worksheethc_edit: data[37].permission,
                                worksheethc_done: data[38].permission,
                                mainservicehc_view: data[39].permission,
                                mainservicehc_add: data[40].permission,
                                mainservicehc_edit: data[41].permission,
                                mainservicehc_delete: data[42].permission,
                                subservicehc_view: data[43].permission,
                                subservicehc_add: data[44].permission,
                                subservicehc_edit: data[45].permission,
                                subservicehc_delete: data[46].permission,
                                worksheetjt_view: data[47].permission,
                                worksheetjt_add: data[48].permission,
                                worksheetjt_edit: data[49].permission,
                                worksheetjt_done: data[50].permission,
                                mainservicejt_view: data[51].permission,
                                mainservicejt_add: data[52].permission,
                                mainservicejt_edit: data[53].permission,
                                mainservicejt_delete: data[54].permission,
                                subservicejt_view: data[55].permission,
                                subservicejt_add: data[56].permission,
                                subservicejt_edit: data[57].permission,
                                subservicejt_delete: data[58].permission,
                                reporthc_view: data[59].permission,
                                reporthc_download: data[60].permission,
                                reportjt_view: data[61].permission,
                                reportjt_download: data[62].permission,
                                reportps_view: data[63].permission,
                                reportps_download: data[64].permission,
                                amount_view: data[65].permission,
                                amount_add: data[66].permission,
                                amount_edit: data[67].permission,
                                amount_delete: data[68].permission,
                                amount_download: data[69].permission,
                                commonfee_view: data[70].permission,
                                commonfee_add: data[71].permission,
                                commonfee_edit: data[72].permission,
                                commonfee_delete: data[73].permission,
                                community_view: data[74].permission,
                                community_add: data[75].permission,
                                community_edit: data[76].permission,
                                community_delete: data[77].permission,
                                boxnews_view: data[78].permission,
                                boxnews_add: data[79].permission,
                                boxnews_edit: data[80].permission,
                                boxnews_delete: data[81].permission,
                                boxnews_send: data[82].permission,
                                regulation_view: data[83].permission,
                                regulation_add: data[84].permission,
                                regulation_edit: data[85].permission,
                                regulation_delete: data[86].permission,
                                servicefee_view: data[87].permission,
                                servicefee_add: data[88].permission,
                                servicefee_edit: data[89].permission,
                                servicefee_delete: data[90].permission,
                                overviewfee_view: data[91].permission,
                                overviewfee_add: data[92].permission,
                                overviewfee_edit: data[93].permission,
                                overviewfee_delete: data[94].permission,
                                houseprogress_view: data[95].permission,
                                houseprogress_add: data[96].permission,
                                houseprogress_edit: data[97].permission,
                                houseprogress_delete: data[98].permission,
                                houseprogress_download: data[99].permission,
                                privilegemgm_view: data[100].permission,
                                privilegemgm_add: data[101].permission,
                                privilegemgm_edit: data[102].permission,
                                privilegemgm_delete: data[103].permission,
                                privilegeevent_view: data[104].permission,
                                privilegeevent_add: data[105].permission,
                                privilegeevent_edit: data[106].permission,
                                privilegeevent_delete: data[107].permission,
                                privilegeeventregister_view: data[108].permission,
                                privilegepoint_view: data[109].permission,
                                privilegepoint_add: data[110].permission,
                                privilegepoint_edit: data[111].permission,
                                privilegepoint_delete: data[112].permission,
                                privilegepointhistory_view: data[113].permission,
                                beyondservice_view: data[114].permission,
                                beyondservice_add: data[115].permission,
                                beyondservice_edit: data[116].permission,
                                beyondservice_delete: data[117].permission,
                                blogs_view: data[118].permission,
                                blogs_add: data[119].permission,
                                blogs_edit: data[120].permission,
                                blogs_delete: data[121].permission,
                                tips_view: data[122].permission,
                                tips_add: data[123].permission,
                                tips_edit: data[124].permission,
                                tips_delete: data[125].permission,
                                mainservicetips_view: data[126].permission,
                                mainservicetips_add: data[127].permission,
                                mainservicetips_edit: data[128].permission,
                                mainservicetips_delete: data[129].permission,
                                subservicetips_view: data[130].permission,
                                subservicetips_add: data[131].permission,
                                subservicetips_edit: data[132].permission,
                                subservicetips_delete: data[133].permission,
                                bannerhome_view: data[134].permission,
                                bannerhome_add: data[135].permission,
                                bannerhome_edit: data[136].permission,
                                bannerhome_delete: data[137].permission,
                                bannerpromotion_view: data[138].permission,
                                bannerpromotion_add: data[139].permission,
                                bannerpromotion_edit: data[140].permission,
                                bannerpromotion_delete: data[141].permission,
                                projectdetail_view: data[142].permission,
                                projectdetail_add: data[143].permission,
                                projectdetail_edit: data[144].permission,
                                projectdetail_delete: data[145].permission,
                                trackingdata_view: data[146].permission,
                                presaleregister_view: data[147].permission,
                                presalepromotion_view: data[148].permission,
                                presalecontact_view: data[149].permission,
                                aboutus_view: data[150].permission,
                                aboutus_add: data[151].permission,
                                aboutus_edit: data[152].permission,
                                aboutus_delete: data[153].permission,
                                contactus_add: data[154].permission,
                                contactus_edit: data[155].permission,
                                emergencycall_view: data[156].permission,
                                emergencycall_add: data[157].permission,
                                emergencycall_edit: data[158].permission,
                                emergencycall_delete: data[159].permission,
                                mailandparcel_view: data[160].permission,
                                mailandparcel_add: data[161].permission,
                                mailandparcel_edit: data[162].permission,
                                mailandparcel_delete: data[163].permission,
                                chat_view: data[164].permission,
                                notification_view: data[165].permission,
                                notification_add: data[166].permission,
                                notification_edit: data[167].permission,
                                notification_delete: data[168].permission,
                                notification_send: data[169].permission,
                                policy_view: data[170].permission,
                                policy_edit: data[171].permission,
                                policytracking_view: data[172].permission,
                                policytracking_export: data[173].permission,
                                permission_view: data[174].permission,
                                permission_add: data[175].permission,
                                permission_edit: data[176].permission,
                                permission_delete: data[177].permission,
                                permission_manage: data[178].permission,
                                users_view: data[179].permission,
                                users_add: data[180].permission,
                                users_edit: data[181].permission,
                                users_delete: data[182].permission,
                                nirvana_view: data[183].permission,
                                nirvana_add: data[184].permission,
                                nirvana_edit: data[185].permission,
                                nirvana_delete: data[186].permission,
                                member_logs: data[187].permission,
                                groupservicejt_view: data[188].permission,
                                groupservicejt_add: data[189].permission,
                                groupservicejt_edit: data[190].permission,
                                groupservicejt_delete: data[191].permission,
                                groupservicehc_view: data[192].permission,
                                groupservicehc_add: data[193].permission,
                                groupservicehc_edit: data[194].permission,
                                groupservicehc_delete: data[195].permission,
                                dashboard_callcenter: data[196].permission,
                                configemail: data[197].permission,
                                worksheetcc_view: data[198].permission,
                                worksheetcc_edit: data[199].permission,
                                worksheetcc_done: data[200].permission,
                                mainservicecc_view: data[201].permission,
                                mainservicecc_add: data[202].permission,
                                mainservicecc_edit: data[203].permission,
                                mainservicecc_delete: data[204].permission,
                                groupservicecc_view: data[205].permission,
                                groupservicecc_add: data[206].permission,
                                groupservicecc_edit: data[207].permission,
                                groupservicecc_delete: data[208].permission,
                                subservicecc_view: data[209].permission,
                                subservicecc_add: data[210].permission,
                                subservicecc_edit: data[211].permission,
                                subservicecc_delete: data[212].permission,
                                member_import: data[213].permission,
                                member_export: data[214].permission,
                                member_download: data[215].permission,
                                residents_download: data[216].permission,
                                memberdelete_view: data[217].permission,
                                memberdelete_export: data[218].permission,
                                nirvana_export: data[219].permission,
                                register_export: data[220].permission,
                                auto_view: data[221].permission,
                                auto_import: data[222].permission,
                                auto_export: data[223].permission,
                                auto_download: data[224].permission,
                                hometype_export: data[225].permission,
                                projecttype_export: data[226].permission,
                                projecthome_export: data[227].permission,
                                amount_import: data[228].permission,
                                amount_export: data[229].permission,
                                amount_downloadAll: data[230].permission,
                                servicefee_import: data[231].permission,
                                servicefee_download: data[232].permission,
                                privilegemgm_export: data[233].permission,
                                privilegeevent_export: data[234].permission,
                                privilegeeventregister_export: data[235].permission,
                                beyondservice_import: data[236].permission,
                                beyondservice_export: data[237].permission,
                                beyondservice_download: data[238].permission,
                                tips_export: data[239].permission,
                                bannerhome_export: data[240].permission,
                                bannerpromotion_export: data[241].permission,
                                projectdetail_export: data[242].permission,
                                trackingdata_export: data[243].permission,
                                presaleregister_export: data[244].permission,
                                presalepromotion_export: data[245].permission,
                                presalecontact_export: data[246].permission,
                                policymember_view: data[247].permission,
                                policymember_export: data[248].permission,
                                houseprogress_export: data[249].permission,
                                worksheet_view: data[250].permission,
                                mycase_view: data[251].permission,
                                mycase_edit: data[252].permission,
                                donecase_view:  data[253].permission,
                                donecase_edit: data[254].permission,
                                allcase_view: data[255].permission,
                                allcase_edit: data[256].permission,
                                customeprofile_view: data[257].permission,
                                customeprofile_viewcase: data[258].permission,
                                customeprofile_create: data[259].permission,
                                customehis_view: data[260].permission,
                                customehis_edit: data[261].permission,
                                newform_create: data[262].permission
                            });
                        }
                    } else {
                        if (data.length > 0) {
                            console.log(`data`)
                            console.log(data)
                            console.log(`data14`)
                            console.log(data[14])
                            this.setState({
                                member_payment: data[0].permission,
                                member_houseprogress: data[1].permission,
                                member_privileges: data[2].permission,
                                member_beyondservice: data[3].permission,
                                member_repair: data[4].permission,
                                member_appeal: data[5].permission,
                                member_blogs: data[6].permission,
                                member_tips: data[7].permission,
                                member_addmember: data[8].permission,
                                member_chat: data[9].permission,
                                member_juristic: data[10].permission,
                                member_mail: data[11].permission,
                                member_emergencycall: data[12].permission,
                                member_presale: data[13].permission,
                                member_get_member: data[14].permission
                            })
                        }
                    }
    
                    this.setState({
                        permissionIsOpen: true,
                        masterType: master_type,
                        masterType_name: master_type.split(",")[1]
                    });
                }).catch(err => {
                    console.log(`error durring permission`)
                    console.log(err)
                });
        } catch (err) {
            console.log(`error durring permission`)
            console.log(err)
        }
    }

    submitPermission() {
        try {
            var ListPermission = []
            if (this.state.masterType_name == "User") {
                ListPermission = {
                    dashboard_presale: this.state.dashboard_presale,
                    dashboard_homecare: this.state.dashboard_homecare,
                    dashboard_juristic: this.state.dashboard_juristic,
                    member_view: this.state.member_view,
                    member_add: this.state.member_add,
                    member_edit: this.state.member_edit,
                    member_delete: this.state.member_delete,
                    residents_view: this.state.residents_view,
                    residents_add: this.state.residents_add,
                    residents_edit: this.state.residents_edit,
                    residents_delete: this.state.residents_delete,
                    guest_view: this.state.guest_view,
                    guest_add: this.state.guest_add,
                    guest_edit: this.state.guest_edit,
                    guest_delete: this.state.guest_delete,
                    register_view: this.state.register_view,
                    register_add: this.state.register_add,
                    residence_view: this.state.residence_view,
                    residence_add: this.state.residence_add,
                    residence_edit: this.state.residence_edit,
                    residence_delete: this.state.residence_delete,
                    residence_export: this.state.residence_export,
                    residence_import: this.state.residence_import,
                    hometype_view: this.state.hometype_view,
                    hometype_add: this.state.hometype_add,
                    hometype_edit: this.state.hometype_edit,
                    hometype_delete: this.state.hometype_delete,
                    projecttype_view: this.state.projecttype_view,
                    projecttype_add: this.state.projecttype_add,
                    projecttype_edit: this.state.projecttype_edit,
                    projecttype_delete: this.state.projecttype_delete,
                    projecthome_view: this.state.projecthome_view,
                    projecthome_add: this.state.projecthome_add,
                    projecthome_edit: this.state.projecthome_edit,
                    projecthome_delete: this.state.projecthome_delete,
                    worksheethc_view: this.state.worksheethc_view,
                    worksheethc_add: this.state.worksheethc_add,
                    worksheethc_edit: this.state.worksheethc_edit,
                    worksheethc_done: this.state.worksheethc_done,
                    mainservicehc_view: this.state.mainservicehc_view,
                    mainservicehc_add: this.state.mainservicehc_add,
                    mainservicehc_edit: this.state.mainservicehc_edit,
                    mainservicehc_delete: this.state.mainservicehc_delete,
                    subservicehc_view: this.state.subservicehc_view,
                    subservicehc_add: this.state.subservicehc_add,
                    subservicehc_edit: this.state.subservicehc_edit,
                    subservicehc_delete: this.state.subservicehc_delete,
                    worksheetjt_view: this.state.worksheetjt_view,
                    worksheetjt_add: this.state.worksheetjt_add,
                    worksheetjt_edit: this.state.worksheetjt_edit,
                    worksheetjt_done: this.state.worksheetjt_done,
                    mainservicejt_view: this.state.mainservicejt_view,
                    mainservicejt_add: this.state.mainservicejt_add,
                    mainservicejt_edit: this.state.mainservicejt_edit,
                    mainservicejt_delete: this.state.mainservicejt_delete,
                    subservicejt_view: this.state.subservicejt_view,
                    subservicejt_add: this.state.subservicejt_add,
                    subservicejt_edit: this.state.subservicejt_edit,
                    subservicejt_delete: this.state.subservicejt_delete,
                    reporthc_view: this.state.reporthc_view,
                    reporthc_download: this.state.reporthc_download,
                    reportjt_view: this.state.reportjt_view,
                    reportjt_download: this.state.reportjt_download,
                    reportps_view: this.state.reportps_view,
                    reportps_download: this.state.reportps_download,
                    amount_view: this.state.amount_view,
                    amount_add: this.state.amount_add,
                    amount_edit: this.state.amount_edit,
                    amount_delete: this.state.amount_delete,
                    amount_download: this.state.amount_download,
                    commonfee_view: this.state.commonfee_view,
                    commonfee_add: this.state.commonfee_add,
                    commonfee_edit: this.state.commonfee_edit,
                    commonfee_delete: this.state.commonfee_delete,
                    community_view: this.state.community_view,
                    community_add: this.state.community_add,
                    community_edit: this.state.community_edit,
                    community_delete: this.state.community_delete,
                    boxnews_view: this.state.boxnews_view,
                    boxnews_add: this.state.boxnews_add,
                    boxnews_edit: this.state.boxnews_edit,
                    boxnews_delete: this.state.boxnews_delete,
                    boxnews_send: this.state.boxnews_send,
                    regulation_view: this.state.regulation_view,
                    regulation_add: this.state.regulation_add,
                    regulation_edit: this.state.regulation_edit,
                    regulation_delete: this.state.regulation_delete,
                    servicefee_view: this.state.servicefee_view,
                    servicefee_add: this.state.servicefee_add,
                    servicefee_edit: this.state.servicefee_edit,
                    servicefee_delete: this.state.servicefee_delete,
                    overviewfee_view: this.state.overviewfee_view,
                    overviewfee_add: this.state.overviewfee_add,
                    overviewfee_edit: this.state.overviewfee_edit,
                    overviewfee_delete: this.state.overviewfee_delete,
                    houseprogress_view: this.state.houseprogress_view,
                    houseprogress_add: this.state.houseprogress_add,
                    houseprogress_edit: this.state.houseprogress_edit,
                    houseprogress_delete: this.state.houseprogress_delete,
                    houseprogress_download: this.state.houseprogress_download,
                    privilegemgm_view: this.state.privilegemgm_view,
                    privilegemgm_add: this.state.privilegemgm_add,
                    privilegemgm_edit: this.state.privilegemgm_edit,
                    privilegemgm_delete: this.state.privilegemgm_delete,
                    privilegeevent_view: this.state.privilegeevent_view,
                    privilegeevent_add: this.state.privilegeevent_add,
                    privilegeevent_edit: this.state.privilegeevent_edit,
                    privilegeevent_delete: this.state.privilegeevent_delete,
                    privilegeeventregister_view: this.state.privilegeeventregister_view,
                    privilegepoint_view: this.state.privilegepoint_view,
                    privilegepoint_add: this.state.privilegepoint_add,
                    privilegepoint_edit: this.state.privilegepoint_edit,
                    privilegepoint_delete: this.state.privilegepoint_delete,
                    privilegepointhistory_view: this.state.privilegepointhistory_view,
                    beyondservice_view: this.state.beyondservice_view,
                    beyondservice_add: this.state.beyondservice_add,
                    beyondservice_edit: this.state.beyondservice_edit,
                    beyondservice_delete: this.state.beyondservice_delete,
                    blogs_view: this.state.blogs_view,
                    blogs_add: this.state.blogs_add,
                    blogs_edit: this.state.blogs_edit,
                    blogs_delete: this.state.blogs_delete,
                    tips_view: this.state.tips_view,
                    tips_add: this.state.tips_add,
                    tips_edit: this.state.tips_edit,
                    tips_delete: this.state.tips_delete,
                    mainservicetips_view: this.state.mainservicetips_view,
                    mainservicetips_add: this.state.mainservicetips_add,
                    mainservicetips_edit: this.state.mainservicetips_edit,
                    mainservicetips_delete: this.state.mainservicetips_delete,
                    subservicetips_view: this.state.subservicetips_view,
                    subservicetips_add: this.state.subservicetips_add,
                    subservicetips_edit: this.state.subservicetips_edit,
                    subservicetips_delete: this.state.subservicetips_delete,
                    bannerhome_view: this.state.bannerhome_view,
                    bannerhome_add: this.state.bannerhome_add,
                    bannerhome_edit: this.state.bannerhome_edit,
                    bannerhome_delete: this.state.bannerhome_delete,
                    bannerpromotion_view: this.state.bannerpromotion_view,
                    bannerpromotion_add: this.state.bannerpromotion_add,
                    bannerpromotion_edit: this.state.bannerpromotion_edit,
                    bannerpromotion_delete: this.state.bannerpromotion_delete,
                    projectdetail_view: this.state.projectdetail_view,
                    projectdetail_add: this.state.projectdetail_add,
                    projectdetail_edit: this.state.projectdetail_edit,
                    projectdetail_delete: this.state.projectdetail_delete,
                    trackingdata_view: this.state.trackingdata_view,
                    presaleregister_view: this.state.presaleregister_view,
                    presalepromotion_view: this.state.presalepromotion_view,
                    presalecontact_view: this.state.presalecontact_view,
                    aboutus_view: this.state.aboutus_view,
                    aboutus_add: this.state.aboutus_add,
                    aboutus_edit: this.state.aboutus_edit,
                    aboutus_delete: this.state.aboutus_delete,
                    contactus_add: this.state.contactus_add,
                    contactus_edit: this.state.contactus_edit,
                    emergencycall_view: this.state.emergencycall_view,
                    emergencycall_add: this.state.emergencycall_add,
                    emergencycall_edit: this.state.emergencycall_edit,
                    emergencycall_delete: this.state.emergencycall_delete,
                    mailandparcel_view: this.state.mailandparcel_view,
                    mailandparcel_add: this.state.mailandparcel_add,
                    mailandparcel_edit: this.state.mailandparcel_edit,
                    mailandparcel_delete: this.state.mailandparcel_delete,
                    chat_view: this.state.chat_view,
                    notification_view: this.state.notification_view,
                    notification_add: this.state.notification_add,
                    notification_edit: this.state.notification_edit,
                    notification_delete: this.state.notification_delete,
                    notification_send: this.state.notification_send,
                    policy_view: this.state.policy_view,
                    policy_edit: this.state.policy_edit,
                    policytracking_view: this.state.policytracking_view,
                    policytracking_export: this.state.policytracking_export,
                    permission_view: this.state.permission_view,
                    permission_add: this.state.permission_add,
                    permission_edit: this.state.permission_edit,
                    permission_delete: this.state.permission_delete,
                    permission_manage: this.state.permission_manage,
                    users_view: this.state.users_view,
                    users_add: this.state.users_add,
                    users_edit: this.state.users_edit,
                    users_delete: this.state.users_delete,
                    nirvana_view: this.state.nirvana_view,
                    nirvana_add: this.state.nirvana_add,
                    nirvana_edit: this.state.nirvana_edit,
                    nirvana_delete: this.state.nirvana_delete,
                    member_logs: this.state.member_logs,
                    groupservicejt_view: this.state.groupservicejt_view,
                    groupservicejt_add: this.state.groupservicejt_add,
                    groupservicejt_edit: this.state.groupservicejt_edit,
                    groupservicejt_delete: this.state.groupservicejt_delete,
                    groupservicehc_view: this.state.groupservicehc_view,
                    groupservicehc_add: this.state.groupservicehc_add,
                    groupservicehc_edit: this.state.groupservicehc_edit,
                    groupservicehc_delete: this.state.groupservicehc_delete,
                    dashboard_callcenter: this.state.dashboard_callcenter,
                    configemail: this.state.configemail,
                    worksheetcc_view: this.state.worksheetcc_view,
                    worksheetcc_edit: this.state.worksheetcc_edit,
                    worksheetcc_done: this.state.worksheetcc_done,
                    mainservicecc_view: this.state.mainservicecc_view,
                    mainservicecc_add: this.state.mainservicecc_add,
                    mainservicecc_edit: this.state.mainservicecc_edit,
                    mainservicecc_delete: this.state.mainservicecc_delete,
                    groupservicecc_view: this.state.groupservicecc_view,
                    groupservicecc_add: this.state.groupservicecc_add,
                    groupservicecc_edit: this.state.groupservicecc_edit,
                    groupservicecc_delete: this.state.groupservicecc_delete,
                    subservicecc_view: this.state.subservicecc_view,
                    subservicecc_add: this.state.subservicecc_add,
                    subservicecc_edit: this.state.subservicecc_edit,
                    subservicecc_delete: this.state.subservicecc_delete,
                    member_import: this.state.member_import,
                    member_export: this.state.member_export,
                    member_download: this.state.member_download,
                    residents_download: this.state.residents_download,
                    memberdelete_view: this.state.memberdelete_view,
                    memberdelete_export: this.state.memberdelete_export,
                    nirvana_export: this.state.nirvana_export,
                    register_export: this.state.register_export,
                    auto_view: this.state.auto_view,
                    auto_import: this.state.auto_import,
                    auto_export: this.state.auto_export,
                    auto_download: this.state.auto_download,
                    hometype_export: this.state.hometype_export,
                    projecttype_export: this.state.projecttype_export,
                    projecthome_export: this.state.projecthome_export,
                    amount_import: this.state.amount_import,
                    amount_export: this.state.amount_export,
                    amount_downloadAll: this.state.amount_downloadAll,
                    servicefee_import: this.state.servicefee_import,
                    servicefee_download: this.state.servicefee_download,
                    privilegemgm_export: this.state.privilegemgm_export,
                    privilegeevent_export: this.state.privilegeevent_export,
                    privilegeeventregister_export: this.state.privilegeeventregister_export,
                    beyondservice_import: this.state.beyondservice_import,
                    beyondservice_export: this.state.beyondservice_export,
                    beyondservice_download: this.state.beyondservice_download,
                    tips_export: this.state.tips_export,
                    bannerhome_export: this.state.bannerhome_export,
                    bannerpromotion_export: this.state.bannerpromotion_export,
                    projectdetail_export: this.state.projectdetail_export,
                    trackingdata_export: this.state.trackingdata_export,
                    presaleregister_export: this.state.presaleregister_export,
                    presalepromotion_export: this.state.presalepromotion_export,
                    presalecontact_export: this.state.presalecontact_export,
                    policymember_view: this.state.policymember_view,
                    policymember_export: this.state.policymember_export,
                    houseprogress_export: this.state.houseprogress_export,
                    worksheet_view: this.state.worksheet_view,
                    mycase_view: this.state.mycase_view,
                    mycase_edit: this.state.mycase_edit,
                    donecase_view:  this.state.donecase_view,
                    donecase_edit: this.state.donecase_edit,
                    allcase_view: this.state.allcase_view,
                    allcase_edit: this.state.allcase_edit,
                    customeprofile_view: this.state.customeprofile_view,
                    customeprofile_viewcase: this.state.customeprofile_viewcase,
                    customeprofile_create: this.state.customeprofile_create,
                    customehis_view: this.state.customehis_view,
                    customehis_edit: this.state.customehis_edit,
                    newform_create: this.state.newform_create,
                }
            } else {
                ListPermission = {
                    "PAYMENT": this.state.member_payment,
                    "ความคืบหน้าโครงการ": this.state.member_houseprogress,
                    "POINT & PRIVILEGE": this.state.member_privileges,
                    "BEYOND Services": this.state.member_beyondservice,
                    "PERFECT SERVICE": this.state.member_repair,
                    "ข้อเสนอแนะ": this.state.member_appeal,
                    "BLOG": this.state.member_blogs,
                    "เคล็ดลับ": this.state.member_tips,
                    "ADD MEMBER": this.state.member_addmember,
                    "แชท": this.state.member_chat,
                    "นิติบุคคล": this.state.member_juristic,
                    "จดหมายและพัสดุ": this.state.member_mail,
                    "เบอร์ฉุกเฉิน": this.state.member_emergencycall,
                    "MY HOME": this.state.member_presale,
                    "MEMBER GET MEMBER": this.state.member_get_member
                }
            }
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    type: this.state.masterType.split(',')[1],
                    ListPermission: JSON.stringify(ListPermission),
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/permissionMenus/' + this.state.masterType.split(',')[0], requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        permissionIsOpen: false,
                        spinner: true
                    });
                }).catch(err => {
                    console.log(`error durring submit permission`)
                    console.log(err)
                });
            this.dataTable()
        } catch (error) {
            console.log(`error durring submit permission`)
            console.log(error)
        }
    }


    async openEdit(e) {
        try {
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };


        var body = `?type=${e.currentTarget.attributes["data-id"].value.split(",")[1]}`
        const response = await fetch(config.url.API_URL + `/getpermissionType/${e.currentTarget.attributes["data-id"].value.split(",")[0]}${body}`, requestOptions)
        const json = await response.json();
        var data = json.data;
        this.setState({
            add_id: data.id,
            add_name: data.name,
            add_type: data.type,
            add_description: data.description,
            active: data.active,
            addIsOpen: true,
            methodOpen: 'edit'
        });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }
    closePermission() {
        this.setState({ permissionIsOpen: false });
        this.clearStatePermissionForm()
        // this.dataTable()
    }

    closeDelete() {
        this.setState({ deleteIsOpen: false });
        // this.dataTable();
    }

    closeAdd() {
        this.setState({
            add_id: '',
            add_name: '',
            add_name_en: '',
        });
        this.setState({ addIsOpen: false });
        // this.dataTable();
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
        this.clearStateFilterForm()
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_active: false,
            src_nonactive: false,
            add_name: '',
            add_type: '',
            page: 0
        });
    }

    submitAdd() {
        try {
            if (!this.state.add_name) {
                alert('ไม่พบข้อมูลชื่อ');
                return;
            }
    
            if (!this.state.add_type) {
                alert('ไม่พบข้อมูลประเภท');
                return;
            }
    
            //console.log(jwt);
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    name: this.state.add_name,
                    description: this.state.add_description,
                    type: this.state.add_type,
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/permissionType', requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        spinner: true
                    });
                }).catch(err => {
                    console.log(`error durring submit add`)
                    console.log(err)
                });
            this.dataTable()
            this.setState({ addIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openDelete(e) {
        this.setState({
            deleteIsOpen: true,
            content_id: e.currentTarget.attributes["data-id"].value
        });
    }

    submitDelete(e) {
        try {
            this.setState({spinner: true})
            const requestOptions = {
                method: 'DELETE',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id,
                    type: this.state.content_id.split(",")[1]
                }),
            };
            fetch(config.url.API_URL + `/getpermissionType/${this.state.content_id.split(",")[0]}`, requestOptions)
                .then(res => res.json())
                .then(data => {
    
                    if(data.status == "Success"){
                        this.dataTable()
                        this.setState({
                            updateIsOpen: true,
                            spinner: false,
                        });
                    }else{
                        this.setState({spinner: false,updateIsOpen: false})
                        alert("Update Failed")
                    }
                }).catch(err => {
                    console.log(`error durring submit delete`)
                    console.log(err)
                });
    
            this.setState({ deleteIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleCheck(event) {
        var name = event.target.name
        this.setState({
            [name]: event.target.checked
        })
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    onChange(e) {
        this.setState({ file: e.target.files[0] });
    }

    handleActiveSrcCheck() {
        this.setState({
            src_active: !this.state.src_active
        });
    }

    handleNonActiveSrcCheck() {
        this.setState({
            src_nonactive: !this.state.src_nonactive
        });
    }

    render() {
        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Permission List</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Permission</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    {(this.state.user_permission[175].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openAdd}>เพิ่มข้อมูล</div>
                                    )}
                                </div>
                                {/* .card-header */}
                                <div className="card-body">
                                {
                                        this.state.spinner && <div style={{ textAlign: 'center' }}><CircularProgress /></div>
                                    }
                                    {
                                        !this.state.spinner && 
                                        <TableContainer>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: 'auto' }}>No</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่อประเภท</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>รายละเอียด</StyledTableCell>
                                                    {/* <StyledTableCell style={{ width: 'auto' }}>ประเภท</StyledTableCell> */}
                                                    <StyledTableCell style={{ width: 'auto' }}>ใช้งาน</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>วันที่สร้าง</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>อัพเดทล่าสุด</StyledTableCell>
                                                    <StyledTableCell style={{ width: 100 }}>จัดการสิทธิ์</StyledTableCell>
                                                    <StyledTableCell style={{ width: 100 }}>การจัดการ</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                                                    <StyledTableCell>{data.name}</StyledTableCell>
                                                                    <StyledTableCell>{data.description}</StyledTableCell>
                                                                    {/* <StyledTableCell>{data.type == "Member" ? "Mobile" : "Back office"}</StyledTableCell> */}
                                                                    <StyledTableCell>{helpers.getActiveStatus(data.active_status)}</StyledTableCell>
                                                                    <StyledTableCell>{data.create}</StyledTableCell>
                                                                    {data.updateby != undefined && <StyledTableCell>{data.updateby}<br />{data.updateby == undefined ? data.updated : data.updated}</StyledTableCell>}
                                                                    {data.updateby == undefined && <StyledTableCell>{data.updated}</StyledTableCell>}
                                                                    <StyledTableCell>{(this.state.user_permission[178].permission == 1 &&
                                                                        <button className="btn-action text-center" data-id={data.typeId} onClick={this.openPermission}><img src="dist/img/icon/ic_complaint_top02.png" className="btn-icon" alt="" /></button>
                                                                    )}</StyledTableCell>
                                                                    <StyledTableCell>
                                                                        <button className="btn-action text-center" data-id={data.typeId} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>

                                                                        {(this.state.user_permission[176].permission == 1 && data.id !='5ec144688bf2933dd8ce92c7' &&
                                                                            <button className="btn-action text-center" data-id={data.typeId} onClick={this.openEdit}><img src="dist/img/icon/ic_update.png" className="btn-icon" alt="" />Update</button>
                                                                        )}

                                                                        {((this.state.user_permission[177].permission == 1 && data.name != 'owner' && data.name != 'install' && data.name != 'live' && data.name != 'renter' && data.name != 'Super Admin' && data.name != 'snvd') &&
                                                                            <button className="btn-action text-center" data-id={data.typeId} onClick={this.openDelete}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>
                                                                        )}
                                                                    </StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                    }

                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </section>
                {/* /.content */}
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ประเภท</div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="add_type" onChange={this.change}>
                                        <option value="">เลือกประเภทผู้ใช้</option>
                                        {/* <option value="Member" selected={this.state.add_type === "Member" && "selected"}>Mobile</option> */}
                                        <option value="User" selected={this.state.add_type === "User" && "selected"}>Back office</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อประเภทผู้ใช้</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="add_name" name="add_name" defaultValue={this.state.add_name} onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3" >
                                <div className="col-sm-3 text-right">สถานะ</div>
                                <div className="col-sm-5">
                                    <Checkbox
                                        checked={this.state.src_active}
                                        onChange={this.handleActiveSrcCheck}
                                        color="primary"
                                    /> ใช้งาน
                                    <Checkbox
                                        checked={this.state.src_nonactive}
                                        onChange={this.handleNonActiveSrcCheck}
                                        color="primary"
                                    /> ไม่ได้ใช้งาน
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl">
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && "เพิ่มข้อมูล") || (this.state.methodOpen === 'edit' && "แก้ไขข้อมูล") || (this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อประเภทผู้ใช้<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (((this.state.add_name == 'owner' || this.state.add_name == 'install' || this.state.add_name == 'live' || this.state.add_name == 'renter' || this.state.add_name == 'snvd') && <input type="text" className="form-control" id="add_name" name="add_name" defaultValue={this.state.add_name} onChange={this.change} disabled />) || <input type="text" className="form-control" id="add_name" name="add_name" defaultValue={this.state.add_name} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_name}</div>)}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">รายละเอียด :</div>
                                <div className="col-sm-5">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_description" name="add_description" defaultValue={this.state.add_description} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_description}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ประเภท<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<select className="form-control" name="add_type" onChange={this.change}>
                                            <option value="">เลือกประเภทผู้ใช้</option>
                                            <option value="User" selected={this.state.add_type === "User" && "selected"}>Back office</option>
                                        </select>)
                                        : (<div className="form-control">{this.state.add_type}</div>)}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">สถานะ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<p><Checkbox
                                            checked={this.state.active}
                                            name='active'
                                            onChange={this.handleCheck}
                                            color="primary"
                                        />ใช้งาน</p>)
                                        : (<div>
                                            <p>{this.state.add_active_status}</p>
                                        </div>)}
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen === 'add' &&
                            (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className="btn btn-success" onClick={this.submitAdd}>เพิ่มข้อมูล</button></div>))
                            || (this.state.methodOpen === 'edit' &&
                                (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>))
                            || (this.state.methodOpen === 'view' &&
                                (<div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>))}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.permissionIsOpen} onHide={this.closePermission} size="lg">
                    <ModalHeader>
                        <ModalTitle>จัดการสิทธิ์</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        {this.state.masterType_name == 'User' && <div>
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Back End</a>
                                </li>
                                {/* <li className="nav-item">
                                    <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Call Center</a>
                                </li> */}
                            </ul>
                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    <br/>
                                    <div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Dashboard</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.dashboard_presale} name='dashboard_presale' onChange={this.handleCheck} color="primary" />Presale</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.dashboard_juristic} name='dashboard_juristic' onChange={this.handleCheck} color="primary" />Juristic</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.dashboard_homecare} name='dashboard_homecare' onChange={this.handleCheck} color="primary" />Homecare</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.dashboard_callcenter} name='dashboard_callcenter' onChange={this.handleCheck} color="primary" />Call Center</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ลูกบ้าน / รอโอน</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.member_view} name='member_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.member_add} name='member_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.member_edit} name='member_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.member_delete} name='member_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.member_import} name='member_import' onChange={this.handleCheck} color="primary" />นำเข้าข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div> */}
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.member_export} name='member_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.member_download} name='member_download' onChange={this.handleCheck} color="primary" />ดาวน์โหลดเทมเพลต</p>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ผู้อาศัย / ผู้เช่า</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.residents_view} name='residents_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.residents_add} name='residents_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.residents_edit} name='residents_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.residents_delete} name='residents_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.residents_export} name='residents_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.residents_download} name='residents_download' onChange={this.handleCheck} color="primary" />ดาวน์โหลดเทมเพลต</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ลูกค้าทั่วไป</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.guest_view} name='guest_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.guest_add} name='guest_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.guest_edit} name='guest_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.guest_delete} name='guest_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.guest_export} name='guest_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ลูกค้ายกเลิก</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.memberdelete_view} name='memberdelete_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.memberdelete_export} name='memberdelete_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>NVD Team Test</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.nirvana_view} name='nirvana_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.nirvana_add} name='nirvana_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.nirvana_edit} name='nirvana_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.nirvana_delete} name='nirvana_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.nirvana_export} name='nirvana_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>รออนุมัติ</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.register_view} name='register_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.register_add} name='register_add' onChange={this.handleCheck} color="primary" />การอนุมัติ</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.register_export} name='register_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Auto Approve</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.auto_view} name='auto_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.auto_import} name='auto_import' onChange={this.handleCheck} color="primary" />นำเข้าข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.auto_export} name='auto_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.auto_download} name='auto_download' onChange={this.handleCheck} color="primary" />ดาวน์โหลดเทมเพลต</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>บ้านเลขที่</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.residence_view} name='residence_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.residence_add} name='residence_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.residence_edit} name='residence_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.residence_delete} name='residence_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.residence_export} name='residence_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.residence_import} name='residence_import' onChange={this.handleCheck} color="primary" />นำเข้าข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ประเภทที่อยู่อาศัย</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.hometype_view} name='hometype_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.hometype_add} name='hometype_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.hometype_edit} name='hometype_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.hometype_delete} name='hometype_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.hometype_export} name='hometype_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>แบรนด์</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projecttype_view} name='projecttype_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projecttype_add} name='projecttype_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projecttype_edit} name='projecttype_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projecttype_delete} name='projecttype_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projecttype_export} name='projecttype_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ชื่อโครงการ</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projecthome_view} name='projecthome_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projecthome_add} name='projecthome_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projecthome_edit} name='projecthome_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projecthome_delete} name='projecthome_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projecthome_export} name='projecthome_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Home Care(Worksheet)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.worksheethc_view} name='worksheethc_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.worksheethc_edit} name='worksheethc_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.worksheethc_done} name='worksheethc_done' onChange={this.handleCheck} color="primary" />ปิดใบงาน</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Home Care(Main service)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicehc_view} name='mainservicehc_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicehc_add} name='mainservicehc_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicehc_edit} name='mainservicehc_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicehc_delete} name='mainservicehc_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Home Care(Group service)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.groupservicehc_view} name='groupservicehc_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.groupservicehc_add} name='groupservicehc_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.groupservicehc_edit} name='groupservicehc_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.groupservicehc_delete} name='groupservicehc_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Home Care(Sub service)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicehc_view} name='subservicehc_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicehc_add} name='subservicehc_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicehc_edit} name='subservicehc_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicehc_delete} name='subservicehc_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Call Center(Worksheet)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.worksheetcc_view} name='worksheetcc_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.worksheetcc_edit} name='worksheetcc_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.worksheetcc_done} name='worksheetcc_done' onChange={this.handleCheck} color="primary" />ปิดใบงาน</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Call Center(Main service)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicecc_view} name='mainservicecc_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicecc_add} name='mainservicecc_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicecc_edit} name='mainservicecc_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicecc_delete} name='mainservicecc_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Call Center(Group service)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.groupservicecc_view} name='groupservicecc_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.groupservicecc_add} name='groupservicecc_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.groupservicecc_edit} name='groupservicecc_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.groupservicecc_delete} name='groupservicecc_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Call Center(Sub service)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicecc_view} name='subservicecc_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicecc_add} name='subservicecc_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicecc_edit} name='subservicecc_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicecc_delete} name='subservicecc_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Juristic(Worksheet)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.worksheetjt_view} name='worksheetjt_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.worksheetjt_edit} name='worksheetjt_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.worksheetjt_done} name='worksheetjt_done' onChange={this.handleCheck} color="primary" />ปิดใบงาน</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Juristic(Main service)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicejt_view} name='mainservicejt_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicejt_add} name='mainservicejt_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicejt_edit} name='mainservicejt_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicejt_delete} name='mainservicejt_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Juristic(Group service)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.groupservicejt_view} name='groupservicejt_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.groupservicejt_add} name='groupservicejt_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.groupservicejt_edit} name='groupservicejt_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.groupservicejt_delete} name='groupservicejt_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Juristic(Sub service)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicejt_view} name='subservicejt_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicejt_add} name='subservicejt_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicejt_edit} name='subservicejt_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicejt_delete} name='subservicejt_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Report(Home Care)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.reporthc_view} name='reporthc_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.reporthc_download} name='reporthc_download' onChange={this.handleCheck} color="primary" />ดาวน์โหลด/ปริ้น</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Report(Juristic)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.reportjt_view} name='reportjt_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.reportjt_download} name='reportjt_download' onChange={this.handleCheck} color="primary" />ดาวน์โหลด/ปริ้น</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Report(Presale)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.reportps_view} name='reportps_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.reportps_download} name='reportps_download' onChange={this.handleCheck} color="primary" />ดาวน์โหลด/ปริ้น</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>งวดดาวน์</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.amount_view} name='amount_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.amount_add} name='amount_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.amount_edit} name='amount_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.amount_delete} name='amount_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.amount_import} name='amount_import' onChange={this.handleCheck} color="primary" />นำเข้าข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.amount_export} name='amount_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.amount_download} name='amount_download' onChange={this.handleCheck} color="primary" />ดาวน์โหลดเทมเพลต</p>
                                                    </div>
                                                </div>
                                            </div> */}
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.amount_downloadAll} name='amount_downloadAll' onChange={this.handleCheck} color="primary" />เทมเพลตหลายรายการ</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="row mb-3">
                                <div className="col-sm-3" style={{ textDecoration: "underline" }}>Common Fee</div>
                                <div className="col-sm-3"></div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.commonfee_view} name='commonfee_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.commonfee_add} name='commonfee_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.commonfee_edit} name='commonfee_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.commonfee_delete} name='commonfee_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>แก้ไข Banner</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.community_view} name='community_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.community_add} name='community_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.community_edit} name='community_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.community_delete} name='community_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>กล่องข้อความนิติบุคคล</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.boxnews_view} name='boxnews_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.boxnews_add} name='boxnews_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.boxnews_edit} name='boxnews_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.boxnews_delete} name='boxnews_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.boxnews_send} name='boxnews_send' onChange={this.handleCheck} color="primary" />ส่งข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ระเบียบข้อบังคับ</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.regulation_view} name='regulation_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.regulation_add} name='regulation_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.regulation_edit} name='regulation_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.regulation_delete} name='regulation_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ค่าบริการส่วนกลาง</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.servicefee_view} name='servicefee_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.servicefee_add} name='servicefee_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.servicefee_edit} name='servicefee_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.servicefee_delete} name='servicefee_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.servicefee_import} name='servicefee_import' onChange={this.handleCheck} color="primary" />นำเข้าข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.servicefee_download} name='servicefee_download' onChange={this.handleCheck} color="primary" />ดาวน์โหลดเทมเพลต</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>สรุปค่าบริการส่วนกลาง</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.overviewfee_view} name='overviewfee_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.overviewfee_add} name='overviewfee_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.overviewfee_edit} name='overviewfee_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.overviewfee_delete} name='overviewfee_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>งานก่อสร้างโครงการ</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.houseprogress_view} name='houseprogress_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.houseprogress_add} name='houseprogress_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.houseprogress_edit} name='houseprogress_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.houseprogress_delete} name='houseprogress_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.houseprogress_export} name='houseprogress_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.houseprogress_download} name='houseprogress_download' onChange={this.handleCheck} color="primary" />ดาวน์โหลดเทมเพลต</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Privilege (MGM)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegemgm_view} name='privilegemgm_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegemgm_add} name='privilegemgm_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegemgm_edit} name='privilegemgm_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegemgm_delete} name='privilegemgm_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegemgm_export} name='privilegemgm_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Privilege (Event)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegeevent_view} name='privilegeevent_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegeevent_add} name='privilegeevent_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegeevent_edit} name='privilegeevent_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegeevent_delete} name='privilegeevent_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegeevent_export} name='privilegeevent_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Privilege (Event Register)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegeeventregister_view} name='privilegeeventregister_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegeeventregister_export} name='privilegeeventregister_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Privilege (Point)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegepoint_view} name='privilegepoint_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegepoint_add} name='privilegepoint_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegepoint_edit} name='privilegepoint_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegepoint_delete} name='privilegepoint_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Privilege (Point History)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.privilegepointhistory_view} name='privilegepointhistory_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ส่วนลดร้านค้า</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.beyondservice_view} name='beyondservice_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.beyondservice_add} name='beyondservice_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.beyondservice_edit} name='beyondservice_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.beyondservice_delete} name='beyondservice_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.beyondservice_import} name='beyondservice_import' onChange={this.handleCheck} color="primary" />นำเข้าข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.beyondservice_export} name='beyondservice_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.beyondservice_download} name='beyondservice_download' onChange={this.handleCheck} color="primary" />ดาวน์โหลดเทมเพลต</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ข่าวสาร / กิจกรรม</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.blogs_view} name='blogs_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.blogs_add} name='blogs_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.blogs_edit} name='blogs_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.blogs_delete} name='blogs_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.blogs_export} name='blogs_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Tips</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.tips_view} name='tips_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.tips_add} name='tips_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.tips_edit} name='tips_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.tips_delete} name='tips_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.tips_export} name='tips_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Tips (Main Category)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicetips_view} name='mainservicetips_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicetips_add} name='mainservicetips_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicetips_edit} name='mainservicetips_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mainservicetips_delete} name='mainservicetips_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Tips (Sub Category)</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicetips_view} name='subservicetips_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicetips_add} name='subservicetips_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicetips_edit} name='subservicetips_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.subservicetips_delete} name='subservicetips_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Home Banner</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.bannerhome_view} name='bannerhome_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.bannerhome_add} name='bannerhome_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.bannerhome_edit} name='bannerhome_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.bannerhome_delete} name='bannerhome_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.bannerhome_export} name='bannerhome_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Promotion Banner</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.bannerpromotion_view} name='bannerpromotion_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.bannerpromotion_add} name='bannerpromotion_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.bannerpromotion_edit} name='bannerpromotion_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.bannerpromotion_delete} name='bannerpromotion_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.bannerpromotion_export} name='bannerpromotion_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>โครงการบ้าน</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projectdetail_view} name='projectdetail_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projectdetail_add} name='projectdetail_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projectdetail_edit} name='projectdetail_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projectdetail_delete} name='projectdetail_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.projectdetail_export} name='projectdetail_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ความสนใจโครงการ</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.trackingdata_view} name='trackingdata_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.trackingdata_export} name='trackingdata_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ลูกค้าทั่วไปลงทะเบียน</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.presaleregister_view} name='presaleregister_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.presaleregister_export} name='presaleregister_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ลงทะเบียนโปรโมชัน</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.presalepromotion_view} name='presalepromotion_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.presalepromotion_export} name='presalepromotion_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ลูกค้าติดต่อเจ้าหน้าที่</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.presalecontact_view} name='presalecontact_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.presalecontact_export} name='presalecontact_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>AboutUs</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.aboutus_view} name='aboutus_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.aboutus_add} name='aboutus_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.aboutus_edit} name='aboutus_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.aboutus_delete} name='aboutus_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>Contact Us</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.contactus_add} name='contactus_add' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.contactus_edit} name='contactus_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>เบอร์โทรฉุกเฉิน</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.emergencycall_view} name='emergencycall_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.emergencycall_add} name='emergencycall_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.emergencycall_edit} name='emergencycall_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.emergencycall_delete} name='emergencycall_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>จดหมายและพัสดุ</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mailandparcel_view} name='mailandparcel_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mailandparcel_add} name='mailandparcel_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mailandparcel_edit} name='mailandparcel_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.mailandparcel_delete} name='mailandparcel_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>สนทนากรุ๊ป</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.chat_view} name='chat_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ตั้งแจ้งเตือน</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.notification_view} name='notification_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.notification_add} name='notification_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.notification_edit} name='notification_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.notification_delete} name='notification_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.notification_send} name='notification_send' onChange={this.handleCheck} color="primary" />ส่งข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>นโยบายความเป็นส่วนตัว</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.policy_view} name='policy_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.policy_edit} name='policy_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>นโยบายลูกบ้าน</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.policymember_view} name='policymember_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.policymember_export} name='policymember_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>นโยบายลูกค้าทั่วไป</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.policytracking_view} name='policytracking_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.policytracking_export} name='policytracking_export' onChange={this.handleCheck} color="primary" />นำออกข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>อนุมัติสิทธิ์</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.permission_view} name='permission_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.permission_add} name='permission_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.permission_edit} name='permission_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.permission_delete} name='permission_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.permission_manage} name='permission_manage' onChange={this.handleCheck} color="primary" />จัดการสิทธิ์</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>ผู้ใช้</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.users_view} name='users_view' onChange={this.handleCheck} color="primary" />ดูข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.users_add} name='users_add' onChange={this.handleCheck} color="primary" />เพิ่มข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.users_edit} name='users_edit' onChange={this.handleCheck} color="primary" />แก้ไขข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.users_delete} name='users_delete' onChange={this.handleCheck} color="primary" />ลบข้อมูล</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.member_logs} name='member_logs' onChange={this.handleCheck} color="primary" />Member Logs</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.configemail} name='configemail' onChange={this.handleCheck} color="primary" />Config Email</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    <br/>
                                    <div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}>เปิดใบงาน</div>
                                            <div className="col-sm-3"></div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-12">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <p><Checkbox checked={this.state.worksheet_view} name='worksheet_view' onChange={this.handleCheck} color="primary" />แสดงเมนู</p>
                                                    </div>
                                                </div>
                                                <div style={{ paddingLeft: "25px" }}>
                                                    <div className="row" >
                                                        <div className="col-sm">
                                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}><p>MyCase</p></div>
                                                            <div className="row">
                                                                <div className="col-sm-3">
                                                                    <div className="row">
                                                                        <div className="col-sm">
                                                                            <p><Checkbox checked={this.state.mycase_view} name='mycase_view' onChange={this.handleCheck} color="primary" disabled/>ดูรายละเอียดใบงาน</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-sm-3">
                                                                    <div className="row">
                                                                        <div className="col-sm">
                                                                            <p><Checkbox checked={this.state.mycase_edit} name='mycase_edit' onChange={this.handleCheck} color="primary" />อัพเดทประสานงานใบงาน</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm">
                                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}><p>Done Case</p></div>

                                                            <div className="row">
                                                                <div className="col-sm-3">
                                                                    <div className="row">
                                                                        <div className="col-sm">
                                                                            <p><Checkbox checked={this.state.donecase_view} name='donecase_view' onChange={this.handleCheck} color="primary" disabled/>ดูรายละเอียดใบงาน</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-sm-3">
                                                                    <div className="row">
                                                                        <div className="col-sm">
                                                                            <p><Checkbox checked={this.state.donecase_edit} name='donecase_edit' onChange={this.handleCheck} color="primary" />อัพเดทประสานงานใบงาน</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm">
                                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}><p>All Case</p></div>

                                                            <div className="row">
                                                                <div className="col-sm-3">
                                                                    <div className="row">
                                                                        <div className="col-sm">
                                                                            <p><Checkbox checked={this.state.allcase_view} name='allcase_view' onChange={this.handleCheck} color="primary" disabled/>ดูรายละเอียดใบงาน</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-sm-3">
                                                                    <div className="row">
                                                                        <div className="col-sm">
                                                                            <p><Checkbox checked={this.state.allcase_edit} name='allcase_edit' onChange={this.handleCheck} color="primary" />อัพเดทประสานงานใบงาน</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm">
                                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}><p>Customer Profile</p></div>

                                                            <div className="row">
                                                                <div className="col-sm-3">
                                                                    <div className="row">
                                                                        <div className="col-sm">
                                                                            <p><Checkbox checked={this.state.customeprofile_view} name='customeprofile_view' onChange={this.handleCheck} color="primary" disabled/>ดูรายละเอียดใบงาน</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-sm-3">
                                                                    <div className="row">
                                                                        <div className="col-sm">
                                                                            <p><Checkbox checked={this.state.customeprofile_viewcase} name='customeprofile_viewcase' onChange={this.handleCheck} color="primary" />ดูเคสที่เคยแจ้ง</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-sm-3">
                                                                    <div className="row">
                                                                        <div className="col-sm">
                                                                            <p><Checkbox checked={this.state.customeprofile_create} name='customeprofile_create' onChange={this.handleCheck} color="primary" />เปิด/สร้างใบงาน</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm">
                                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}><p>Customer History</p></div>

                                                            <div className="row">
                                                                <div className="col-sm-3">
                                                                    <div className="row">
                                                                        <div className="col-sm">
                                                                            <p><Checkbox checked={this.state.customehis_view} name='customehis_view' onChange={this.handleCheck} color="primary" />ดูรายละเอียดใบงาน</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-sm-3">
                                                                    <div className="row">
                                                                        <div className="col-sm">
                                                                            <p><Checkbox checked={this.state.customehis_edit} name='customehis_edit' onChange={this.handleCheck} color="primary" />อัพเดทประสานงานใบงาน</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm">
                                                            <div className="col-sm-3" style={{ textDecoration: "underline" }}><p>New Form</p></div>

                                                            <div className="row">
                                                                <div className="col-sm-3">
                                                                    <div className="row">
                                                                        <div className="col-sm">
                                                                            <p><Checkbox checked={this.state.newform_create} name='newform_create' onChange={this.handleCheck} color="primary" />เปิด/สร้างใบงาน</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>}
                        {this.state.masterType_name == 'Member' && <div>
                            <div className="row mb-3">
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_payment} name='member_payment' onChange={this.handleCheck} color="primary" />PAYMENT</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_houseprogress} name='member_houseprogress' onChange={this.handleCheck} color="primary" />House Progress</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_privileges} name='member_privileges' onChange={this.handleCheck} color="primary" />POINT & PRIVILEGE</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_beyondservice} name='member_beyondservice' onChange={this.handleCheck} color="primary" />Beyond Service</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_repair} name='member_repair' onChange={this.handleCheck} color="primary" />PERFECT SERVICE</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_appeal} name='member_appeal' onChange={this.handleCheck} color="primary" />ข้อเสนอแนะ</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_blogs} name='member_blogs' onChange={this.handleCheck} color="primary" />BLOG</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_tips} name='member_tips' onChange={this.handleCheck} color="primary" />เคล็ดลับ</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_addmember} name='member_addmember' onChange={this.handleCheck} color="primary" />ADD MEMBER</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_chat} name='member_chat' onChange={this.handleCheck} color="primary" />แชท</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_juristic} name='member_juristic' onChange={this.handleCheck} color="primary" />นิติบุคคล</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_mail} name='member_mail' onChange={this.handleCheck} color="primary" />จดหมายและพัสดุ</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_emergencycall} name='member_emergencycall' onChange={this.handleCheck} color="primary" />เบอร์โทรฉุกเฉิน</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_presale} name='member_presale' onChange={this.handleCheck} color="primary" />MY HOME</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p><Checkbox checked={this.state.member_get_member} name='member_get_member' onChange={this.handleCheck} color="primary" />MEMBER GET MEMBER</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closePermission}>ยกเลิก</button>&nbsp;&nbsp;
                        {this.state.masterType.split(',')[0] != "5ec144688bf2933dd8ce92c7" ? <button className="btn btn-success" onClick={this.submitPermission}>ตกลง</button> : <></>}
                        
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}